var productLinePage = {
    init: function(){
        this.boxFamilies();
        this.proconsMobile();
        this.textImageMobilAccordion();
    },   
    boxFamilies: function(){
        var mainClass   = '.multi-prod-families',
            $btns       = $(mainClass+'__fam-list a'),
            $wrap       = $(mainClass+'__ajax-wrap'),
            $btnsWrap   = $(mainClass+'__fam-list');

        $btns.first().addClass('active');
        
        $btns.on('click', function(e){
            e.preventDefault();
            
            var $el     = $(this),
                link    =  $el.attr('href');

            $el.addClass('active').siblings().removeClass('active');

            // Calls the collection template, with forced template in order to return the html snippet for this box
            $.ajax({
                url: link + '?view=families-block',
                beforeSend: function(){
                    var wrapHeight = $wrap.outerHeight(true);

                    $wrap.css({'height':wrapHeight}).addClass('ajax-loading');

                },
                success: function (data) {

                    $wrap.find('.family-row').remove();
                    $wrap.append(data).removeAttr('style');

                    setTimeout( function(){
                        $wrap.removeClass('ajax-loading');
                    }, 150);

                    goToPos($btnsWrap);
                },
                error: function(data) {
                   
                }
            });
            
        });
    },
    proconsMobile: function(){
        var $btns = $('.positive-negative__list-mobile-controls');

        $btns.on('click',function(){
            var $el = $(this);

            $el.parents('.row-lists').toggleClass('show-cons');
        });
    },

    textImageMobilAccordion: function(){
        var $btns = $('.text-image-mob-acc__oth-mob-toggle');

        $btns.on('click',function(){
            var $el = $(this);

            $el.parents('.text-image-mob-acc__oth-block').toggleClass('open-accordion');
            setTimeout(function(){
                goToPos($el);
            }, 250);
        });
    }
}


//document ready
$(function() {

    productLinePage.init();

});
